
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
} from '@mui/x-data-grid';
import Box from "@mui/material/Box";

import {
    Avatar,
    Tooltip
} from "@mui/material";

// App Imports
import {getContractStatsEpisode} from "../../Contract/ContractClient";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {changeContractStats} from "./contractStatsSlice";
import {changeContractStatsControls} from "./contractStatsControlsSlice";
import {useNavigate} from "react-router-dom";
import {StatsMenu} from "./StatsMenu";
import {changeWorkQueue} from "../workQueueSlice";


// main function
export default function EpisodeContractStatsGrid() {

    // ****************** BEGIN STATES ****************************

    const [episodeContractStats, setEpisodeContractStats] = useState([]);
    const [gridVisible, setGridVisible] = React.useState(true);



    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************


    const selectorGridDisplay = useSelector((state) => state.contractStatsControlsSlc.value.gridDisplay);
    const selectorSeriesId = useSelector((state) => state.contractStatsSlc.value.seriesId);
    const selectorSeasonId = useSelector((state) => state.contractStatsSlc.value.seasonId);
    const selectorSeasonNumber = useSelector((state) => state.contractStatsSlc.value.season);
    const selectorProductId = useSelector((state) => state.contractStatsSlc.value.productId);
    const hideActions = localStorage.getItem('hideActions') === "true";
    const dispatchData = useDispatch();

    // ********************** END STORE ********************************

    const navigate = useNavigate(); // Hook to programmatically navigate

    // ****************** BEGIN FETCH ****************************

    const fetchEpisodeContractStats = () =>
        getContractStatsEpisode(selectorSeasonId)

            .then(data => {
                console.log(data);
                setEpisodeContractStats(data);
            })
    useEffect(() => {
        fetchEpisodeContractStats();
    }, []);

    // ****************** END FETCH ****************************


    const renderEpisodeContractStats = episodeContractStats => {
        if (episodeContractStats.length <= 0) {
            return "No Data";
        }}


    //
    // useEffect(() => {
    //     fetchEpisodeContractStats();
    //     dispatchData(changeSeriesContractStatControls({dpaGridRefresh: false}));
    // }, [useSelector((state) => state.seriesContractStatControlsSlc.value.dpaGridRefresh)===true]);


    // ****************** BEGIN CRUD ***********************************



    // ****************** END CRUD ***********************************



    // ****************** BEGIN DRILLDOWN ****************************

    const handleDrilldown = (selectSeriesContractStatId,selectSeriesContractStatMcode, selectSeriesContractStatName, selectSeriesContractStatDescription, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        // dispatchData(changeSeriesContractStat({id: selectSeriesContractStatId, mcode: selectSeriesContractStatMcode, name: selectSeriesContractStatName, description: selectSeriesContractStatDescription }));
    }

    // ****************** END DRILLDOWN ****************************

    const handleClickedRow = (episodeContractStats) => {

        console.log('Stats data from clicked row');
        console.log(episodeContractStats);
        dispatchData(changeContractStats({seriesId: episodeContractStats.seriesId,
            seasonId: episodeContractStats.seasonId, productId: episodeContractStats.productId,
            seriesTitle: episodeContractStats.seriesTitle,  seasonName: episodeContractStats.seasonName,
            episodeName: episodeContractStats.episodeName, photoStartDate: episodeContractStats.photoStartDate,
             seasonNumber: episodeContractStats.seasonNumber
        }));


        // dispatchData(changeContractStatsControls({gridDisplay: "Guild"}));
        dispatchData(changeContractStatsControls({gridDisplay: selectorGridDisplay === "EpisodeFullScreen" ? "GuildFullScreen" : "GuildRightPanel"}));
            };


    const handleGoToResiduals = (row) => {
        dispatchData(changeContractStatsControls({gridDisplay: null}));
        dispatchData(changeContractStats({seriesId: row.seriesId,
            seasonId: row.seasonId, productId: row.productId,
            seriesTitle: row.seriesTitle,  seasonName: row.seasonName,
            episodeName: row.episodeName, photoStartDate: row.photoStartDate,
            seasonNumber: row.seasonNumber
        }));
        console.log("series Id to expand from product: ", selectorSeriesId);
        console.log("season Id to expand from product: ", selectorSeasonId);
        console.log("season number to expand from product: ", selectorSeasonNumber);
        console.log("product Id to expand from product: ", selectorProductId);
        dispatchData(changeWorkQueue({contractExpand: true,
            contractExpandHierarchical: row.seriesId !== null,
            contractExpandSeriesId: row.seriesId,
            contractExpandSeasonId: row.seasonId,
            contractExpandSeasonNumber: row.seasonNumber,
            contractExpandProductId: row.productId
        }));
        console.log("series Id to expand from product: ", row.seriesId);
        console.log("season Id to expand from product: ", row.seasonId);
        console.log("season number to expand from product: ", row.seasonNumber);
        console.log("product Id to expand from product: ", row.productId);
        // navigate('/Work');
        // <component={Link} to={"/ExternalData/Financials"}/>
    };


    // ****************** BEGIN COLUMNS ****************************

    const columns = fetchEpisodeContractStats => [

        {    field: 'more',
            headerName: '',
            description: '',
            sortable: true,
            width: 60,
            hide: false,
            renderCell: (params) => (
                <div onClick={(event) => event.stopPropagation()}>
                    <StatsMenu row={params.row}  />
                </div>
            )
        },
        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            width: 60,
            hide: true,
        },
        {
            field: 'seriesTitle',
            headerName: 'Series Title',
            description: '',
            sortable: true,
            editable: true,
            hide: true,
            // editable: true,
            width: 300,
        },
        {
            field: 'seriesId',
            headerName: 'Series ID',
            description: '',
            sortable: false,
            editable: false,
            hide: true,
            width: 80,
        },
        {
            field: 'seasonNumber',
            headerName: 'Season #',
            description: '',
            sortable: true,
            editable: false,
            hide: true,
            // editable: true,
            width: 80,
        },
        {
            field: 'seasonName',
            headerName: 'Season Name',
            description: '',
            sortable: true,
            editable: false,
            hide: true,
            // editable: true,
            width: 200,
        },
        {
            field: 'seasonId',
            headerName: 'Season ID',
            description: '',
            sortable: true,
            editable: false,
            hide: true,
            // editable: true,
            width: 80,
        },

        {
            field: 'productId',
            headerName: 'Product ID',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            // editable: true,
            width: 100,
        },
        {
            field: 'propertyTitle',
            headerName: 'Property Title',
            description: '',
            sortable: true,
            editable: false,
            hide: true,
            // editable: true,
            width: 200,
        },
        {
            field: 'episodeName',
            headerName: 'Episode Name',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            // editable: true,
            width: 200,
        },
        {
            field: 'photoStartDate',
            headerName: 'Photo Start Date',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            // editable: true,
            width: 130,
        },
        {
            field: 'guildCount',
            headerName: 'Guilds',
            width: 100,
            headerAlign: 'center',
            renderCell: (episodeContractStats) => {
                const count = episodeContractStats.row.guildCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of guild contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'guilds',
            headerName: 'Guilds',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            // editable: true,
            width: 250,
        },
        {
            field: 'approvedCount',
            headerName: 'Approved',
            width: 100,
            headerAlign: 'center',
            renderCell: (episodeContractStats) => {
                const count = episodeContractStats.row.approvedCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of approved contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'unapprovedCount',
            headerName: 'Unapproved',
            width: 100,
            headerAlign: 'center',
            renderCell: (episodeContractStats) => {
                const count = episodeContractStats.row.unapprovedCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit
                const avatarColor = count === 0 ? "rgb(30,144,255)" : "warning.main"
                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of unapproved contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                // backgroundColor: "rgb(30,144,255)",
                                backgroundColor: avatarColor,
                                // "warning.main",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        // {
        //     field: 'approvedCount',
        //     headerName: 'Approved',
        //     description: '',
        //     sortable: true,
        //     editable: false,
        //     hide: false,
        //     // editable: true,
        //     width: 100,
        // },
        // {
        //     field: 'unapprovedCount',
        //     headerName: 'Unapproved',
        //     description: '',
        //     sortable: true,
        //     editable: false,
        //     hide: false,
        //     // editable: true,
        //     width: 100,
        // },

    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN TOOLBAR ****************************



    // ****************** END TOOLBAR ****************************

    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            { selectorGridDisplay === "EpisodeFullScreen" &&
                <Box sx={{height: 70, pt: 1, pl: 3}}><h3>Episode Contract Statistics</h3></Box>
            }
            { selectorGridDisplay !== "EpisodeFullScreen" && <Box sx={{height: 20, pt: 1, pl: 3}}/>}
            {/*<Box sx={{height: 70, pt: 1, pl: 3}}>*/}
            {/*    <h3>Episode Contract Statistics</h3>*/}
            {/*</Box>*/}
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                style={{cursor: 'pointer'}}
                aria-label={"EpisodeContractStats"}
                rows={episodeContractStats}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns(fetchEpisodeContractStats)}
                // onRowClick = {(episodeContractStats)=>handleClickedRow(episodeContractStats.row)}
                onRowClick = {(episodeContractStats)=>handleGoToResiduals(episodeContractStats.row)}

                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                // I just added back in rowKey from the AmigosCode example, which should define seriesContractStat and seriesContractStat.id
                // this is needed for identifying which seriesContractStat to delete or edit
                rowKey={seriesContractStat => seriesContractStat.id}
                components={{
                    // Toolbar: CustomToolbar,
                    Footer: CustomFooter,
                }}
            />}
            {/*<div>*/}
            {/*</div>*/}
        </div>
    );

    // ****************** END RETURN ****************************

}

